var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.143 16v6.476H7.905V16zM16 9.524v12.952h-3.238V9.524zm12.952 14.571v1.62H3.048V6.284h1.619v17.81h24.285zm-8.095-11.333v9.714H17.62v-9.714h3.238zm4.857-4.857v14.571h-3.238V7.905z"
})));
export default SvgDashboard;